<template lang="pug">
  .card
    transition(name='fade-quick')
      .overlay-class(
        v-if="mostrarModalEmpleadosConDocumentos"
      )
        .card
          header.card-header
            p.card-header-title
              | ¿SEGURO QUE DESEA CONTINUAR?
          .card-content
            span {{ mensajeRespuesta }}
            .content
              ul
                li.tal(v-for="(nombre, index) in listaEmpleadosRespuesta" :key="index")
                  span {{ nombre }}
          footer.card-footer
            a.card-footer-item(
              @click="validarModalEmpleadoConDocumentos()"
            )
              span(v-if="isSaving") Guardando...
              span(v-else) Continuar
            a.card-footer-item(
              @click="cerrarModalEmpleadosConDocumentos()"
            ) Cancelar
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionModal"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionModal = false"
        @do="validarConfirmacion"
        ref="confirmarEliminar"
      )
        span(slot="title") ¿Está seguro de {{ tipoConfirmacion.descripcion }}?
        span(slot="primaryAction")
          template(v-if="isSaving")
            | Guardando...
          template(v-else)
            | Guardar
    header.card-header
      p.card-header-title Seleccionar los documentos
      .contenedor-acciones
        .button.is-small.is-info(@click="abrirModalConfirmacion('asignarTodos')")
          span.icon.is-small
            i.fa.fa-check
          span Asignar Todos
        .button.is-small.is-danger(@click="abrirModalConfirmacion('desasignarTodos')")
          span.icon.is-small
            i.fa.fa-times
          span Desasignar Todos


    .contenedor-interno
      .search
        .control
          input.input(
            type="text",
            placeholder="Buscar documentos...",
            v-model="filtro"
            @keyup.enter="selectFirst"
            @keyup.esc="close"
            ref="busqueda"
            @input="fetchSearch"
          )
      .data
        transition-group.contenedor-data(v-infinite-scroll="fetchByScroll" infinite-scroll-disabled="disabledScrollExecute" infinite-scroll-distance="2" name="fade-smooth-two" tag="div")
          .usuario(
            v-for="(doc, index) in filteredDocumentos"
            :key="'doc_lookup_'+doc.codigo"
            :class="{ 'selected': doc.nuevoSeleccionado || doc.seleccionado }"
            @click="toggleSelection(doc)"
          )
            .flex
              span.nombre &nbsp;{{ doc.descripcion }}
        .info-message(v-if="!isLoading & filteredDocumentos.length === 0")
          span No se encontraron empleados activos


    footer.card-footer
      a.card-footer-item(
        @click="asignarDocumentos(false)"
      )
        span(v-if="isSaving") Guardando...
        span(v-else) Guardar
      a.card-footer-item(
        @click="close"
      ) Cancelar
</template>

<script>
import { apiDelete, apiGet, apiPost, notify } from '../util/general'
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'

import _ from 'lodash'

export default {
  name: 'document-selector',
  props: {
    idEmpleado: Number // Se pasan como prop los empleados previamente seleccionados
  },
  components: {
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  data () {
    return {
      filteredDocumentos                 : [],
      documentosAuxiliar                 : [],
      filtro                            : '',
      nombreEmpleado                    :localStorage.getItem('nombre'),
      isLoading                         : false,
      isScroll                          : false,
      isSaving                          : false,
      disabledScrollExecute             : true,
      numeroRecnum                      : 0,
      noMore                            : false,
      mostrarModalEmpleadosConDocumentos: false,
      mostrarConfirmacionModal          : false,
      mensajeRespuesta                  : '',
      listaEmpleadosRespuesta           : [],
      tipoConfirmacion                  : {}
    };
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  created () {
    if (this.idEmpleado) {
    }
    this.fetch();
  },
  mounted () {
    this.$refs.busqueda.focus()
  },
  methods: {
    fetchByScroll () {
      this.isScroll = true
      this.fetch()
    },
    fetchSearch : _.debounce(function (value) {
      var vm = this
      vm.fetch()
    }, 300),
    fetch () {
      var vm = this
      vm.isLoading                = true
      vm.disabledScrollExecute   = true
      vm.noMore                   = false
      if (!vm.isScroll) {
        vm.filteredDocumentos = []
        vm.numeroRecnum = 0
      }
      var obj = {
        filtro       : vm.filtro,
        numeroRecnum : vm.numeroRecnum,
        codigoEmpleado: vm.idEmpleado
      }
      apiGet(vm, '/documentos-firmar/seleccionado/documentos', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          const documento = data.lista[i]
          // Verifico en los empleados auxiliar si esta seleccionado o no (esta logica es para que este visualmente seleccionado o no)
          const documentoAux = vm.documentosAuxiliar.find(e => e.codigo === documento.codigo);
          if (documentoAux) {
            documento.seleccionado = documentoAux.seleccionado;
          }
          // Aqui pusheo el empleado debido al scroll infinito
          vm.filteredDocumentos.push(documento)
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.numeroRecnum = data.numeroRecnum
          vm.disabledScrollExecute = false
        }
        vm.isLoading         = false
        vm.isScroll = false
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.disabledScrollExecute = true
        vm.isScroll = false
      })
    },
    toggleSelection (documento) {
      // Actualiza el estado seleccionado del empleado en filteredDocumentos
      documento.seleccionado = !documento.seleccionado;

      // Actualiza el estado seleccionado en documentosAuxiliar
      const index = this.documentosAuxiliar.findIndex(e => e.codigo === documento.codigo);
      if (index !== -1) {
        // Actualiza el estado seleccionado sin modificar otras propiedades
        this.documentosAuxiliar[index].seleccionado = documento.seleccionado;
      } else {
        // Solo guarda el codigo y seleccionado
        this.documentosAuxiliar.push({
          codigo: documento.codigo,
          seleccionado: documento.seleccionado
        });
      }
    },
    close () {
      this.$emit('close');
    },
    selectFirst () {
      if (this.filteredDocumentos.length >= 1) {
        this.toggleSelection(this.filteredDocumentos[0])
      }
    },
    asignarDocumentos (eliminarForzado) {
      var vm = this

      if (vm.isSaving) return;

      vm.isSaving = true

      var obj = {
        documentos: vm.documentosAuxiliar,
        codigoEmpleado: vm.idEmpleado,
        nombreEmpleado: vm.nombreEmpleado
      }
      if (eliminarForzado) {
        obj.eliminarForzado = true
      } else {
        obj.eliminarForzado = false
      }

      apiPost(vm, '/documentos-firmar/asignar-documentos', obj, function (data) {
        if (data.status === 2) {
          vm.mensajeRespuesta = data.message
          vm.listaEmpleadosRespuesta = data.lista
          vm.mostrarModalEmpleadosConDocumentos = true
          return
        }
        if (obj.eliminarForzado) {
          vm.cerrarModalEmpleadosConDocumentos()
        }
        vm.documentosAuxiliar = []
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        vm.close()
        // vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
        apiGet(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length)
        })
      })
    },
    cerrarModalEmpleadosConDocumentos () {
      this.mostrarModalEmpleadosConDocumentos = false
      this.listaEmpleadosRespuesta = []
      this.tipoConfirmacion.tipo = ''
    },
    abrirModalConfirmacion (tipo) {
      this.tipoConfirmacion.tipo = tipo
      this.tipoConfirmacion.descripcion = tipo === 'asignarTodos' ? 'asignar todos los documentos' : 'desasignar todos los documentos'
      this.mostrarConfirmacionModal = true
    },
    validarModalEmpleadoConDocumentos () {
      if (this.tipoConfirmacion.tipo === 'desasignarTodos') {
        this.desasignarTodos(true)
      } else {
        this.asignarDocumentos(true)
      }
    },
    validarConfirmacion () {
      if (this.tipoConfirmacion.tipo === 'asignarTodos') {
        this.asignarTodos()
      } else {
        this.desasignarTodos(false)
      }
      this.mostrarConfirmacionModal = false
    },
    desasignarTodos (desasignarTodos) {
      var vm = this

      if (vm.isSaving) return;

      vm.isSaving = true

      var obj = {
        codigoEmpleado: vm.idEmpleado,
        nombreEmpleado: vm.nombreEmpleado
      }
      if (desasignarTodos) {
        obj.desasignarForzado = true
      } else {
        obj.desasignarForzado = false
      }

      apiDelete(vm, '/documentos-firmar/desasignar-todos/documentos', obj, function (data) {
        if (data.status === 2) {
          vm.mensajeRespuesta = data.message
          vm.listaEmpleadosRespuesta = data.lista
          vm.mostrarModalEmpleadosConDocumentos = true
          return
        }
        if (obj.desasignarForzado) {
          vm.cerrarModalEmpleadosConDocumentos()
        }
        vm.documentosAuxiliar = []
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        vm.close()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
        apiGet(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length)
        })
      })
    },
    asignarTodos () {
      var vm = this

      if (vm.isSaving) return;

      vm.isSaving = true

      var obj = {
        codigoEmpleado: vm.idEmpleado,
        nombreEmpleado: vm.nombreEmpleado
      }

      apiPost(vm, '/documentos-firmar/asignar-todos/documentos', obj, function (data) {
        vm.documentosAuxiliar = []
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        vm.close()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
        apiGet(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length)
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.content
  max-height 180px
  overflow-y auto
.employee-selector
  width 200px
  background-color #f0f4f8
  border-radius 8px
  padding 10px


ul
  list-style none
  padding 0
  margin 0


.selected
  background-color #97c3d7 !important /* Estilo para los seleccionados previamente */


.new-selected
  background-color #61aed1 !important /* Estilo para los nuevos seleccionados */

.color-white
  color #fff



button
  margin-top 10px
  padding 8px 12px
  background-color #007bff
  color white
  border none
  border-radius 4px
  cursor pointer
  transition background-color 0.3s
.contenedor-acciones
  padding 0.75rem
  .button
    margin 5px

button:hover
  background-color #0056b3
.search
  padding 5px 10px
.data
  max-height 250px
  overflow-y auto
  .contenedor-box
    >*
      transition all .5s
      width 100%
  padding 10px
  .usuario
    background #fff
    border-radius 3px
    border 1px solid #d6dadc
    border-bottom-color #c4c9cc
    -webkit-box-shadow 0 1px 6px rgba(0,0,0,.15)
    box-shadow 0 1px 6px rgba(0,0,0,.15)
    padding 10px
    margin-bottom 5px
    cursor pointer
    transition all .2s ease
    width 100%
    &:hover
      background-color #edeff0
      margin-left 4px
      -webkit-box-shadow -8px 0 #959da17d
      box-shadow -8px 0 #959da17d

    .nombre
      flex 1
</style>



// WEBPACK FOOTER //
// Component_Seleccionar_Documentos_Firmar.vue?a6a68e62